(() => {
  const MM_FREE_GIFT_MAX_QUANTITY = 1;

  let mmFreeGiftQuantityPromise = null;

  const getFreeGiftVariantId = () => {
    if (typeof freeUpsellGiftProduct === 'undefined' || freeUpsellGiftProduct?.error) {
      return null;
    }

    return freeUpsellGiftProduct.variants?.[0]?.id ?? null;
  };

  const getFreeGiftLineItem = (cartData) => {
    const variantId = getFreeGiftVariantId();
    if (!variantId || !cartData?.items) {
      return null;
    }

    return cartData.items.find((item) => item.variant_id === variantId) ?? null;
  };

  const fetchCartData = () => {
    const root = window.Shopify?.routes?.root || '/';
    return fetch(`${root}cart.js`).then((response) => response.json());
  };

  const refreshCartDrawer = (response) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !response?.sections) {
      return;
    }

    cartDrawer.renderContents(response);
    if (response.item_count > 0) {
      cartDrawer.classList.remove('is-empty');
    }
  };

  const setFreeGiftQuantity = (quantity) => {
    const variantId = getFreeGiftVariantId();
    if (!variantId) {
      return Promise.resolve(null);
    }

    const cartDrawer = document.querySelector('cart-drawer');
    const root = window.Shopify?.routes?.root || '/';

    if (cartDrawer) {
      cartDrawer.setActiveElement(document.activeElement);

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);
      formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);

      return fetch(`${root}cart/change.js`, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          refreshCartDrawer(response);
          return response;
        });
    }

    return fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    }).then((response) => response.json());
  };

  const enforceFreeGiftQuantity = () => {
    if (mmFreeGiftQuantityPromise) {
      return mmFreeGiftQuantityPromise;
    }

    mmFreeGiftQuantityPromise = fetchCartData()
      .then((cartData) => {
        const giftItem = getFreeGiftLineItem(cartData);

        if (!giftItem || giftItem.quantity <= MM_FREE_GIFT_MAX_QUANTITY) {
          return cartData;
        }

        return setFreeGiftQuantity(MM_FREE_GIFT_MAX_QUANTITY).then(() => fetchCartData());
      })
      .catch((error) => {
        console.error('[mm-free-gift-quantity]', error);
        return null;
      })
      .finally(() => {
        mmFreeGiftQuantityPromise = null;
      });

    return mmFreeGiftQuantityPromise;
  };

  const isCartMutationRequest = (input) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    return /\/cart\/(add|change)\.js/.test(url);
  };

  const patchFetchForCartMutations = () => {
    const originalFetch = window.fetch;

    window.fetch = (...args) =>
      originalFetch.apply(window, args).then((response) => {
        if (response.ok && isCartMutationRequest(args[0])) {
          enforceFreeGiftQuantity();
        }

        return response;
      });
  };

  const initFreeGiftQuantityGuard = () => {
    enforceFreeGiftQuantity();
    patchFetchForCartMutations();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        enforceFreeGiftQuantity();
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreeGiftQuantityGuard);
  } else {
    initFreeGiftQuantityGuard();
  }

  window.mmEnforceFreeGiftQuantity = enforceFreeGiftQuantity;
})();
